import moment from "moment";
import { getDateAsMoment, timestampHasDateTime } from "./dates";

export const isValidDate = (value) => {
    let date = moment(value);
    return date.isValid()
}

export function formattedDate(value, addSeconds?) {
    if (!isValidDate(value)) {
        return '-';
    } 
    if(addSeconds){
        return formatDate(value, addSeconds);
    }else{
        return formatDate(value);
    }   
}

export const getDateFromDateFormatApi = (date: string): Date => getDateAsMoment(date).toDate();


export const formatDate = (
    date: string, 
    addSeconds?: boolean,
    onlyDate?: boolean
) => {
    let showOnlyDate = onlyDate ? onlyDate : false;
    let newDate = getDateFromDateFormatApi(date);
    let dateHasHour = timestampHasDateTime(date);
    let timestamp = '-';
    if (
        !isNaN(newDate.getDate()) &&
        !isNaN(newDate.getMonth()) &&
        !isNaN(newDate.getFullYear()) &&
        !isNaN(newDate.getHours()) &&
        !isNaN(newDate.getMinutes()) &&
        !isNaN(newDate.getSeconds())
    ) {
        let day = newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate();
        let month = newDate.getMonth() + 1;
        let finalMonth = month < 10 ? '0' + month : month;
        let year = newDate.getFullYear();
        let hours = newDate.getHours() < 10 ? '0' + newDate.getHours() : newDate.getHours();
        let minutes = newDate.getMinutes() < 10 ? '0' + newDate.getMinutes() : newDate.getMinutes();
        let seconds = newDate.getSeconds() < 10 ? '0' + newDate.getSeconds() : newDate.getSeconds();
        timestamp = `${day}/${finalMonth}/${year}`;

        if (!showOnlyDate) {
            timestamp += ` - ${hours}:${minutes}`;
            if (addSeconds) {
                timestamp += `:${seconds}`;
            }
        }

        return timestamp;
    }

    return timestamp;
};

export const timestampToTime = value => {
    return new Date(value).getTime();
};

export const parseFloatNumber = (value, decimals?) => {
    let decimalsToReturn = decimals ? decimals : 3;
    if (!isNaN(value) && value !== null) {
        const valueString = value.toString();

        if (valueString.includes('e')) {
            return Number(value).toExponential(decimalsToReturn);
        }

        let onpoint = valueString.split('.', 2);
        let numberStringTruncated = value;
        if (onpoint.length > 1) {
            numberStringTruncated = onpoint[0] + '.' + onpoint[1].substring(0, decimalsToReturn);
        }
        return numberStringTruncated;
    }
}


export const isNumber = value => {
    return !isNaN(parseFloat(value)) && isFinite(value);
};

export function getValueByType(
    value: string | number | null, 
    decimals?
):string | number {
        if(typeof value === 'string' && moment(value, moment.ISO_8601, true).isValid()){
            return formatDate(value, false, true)
        }

        if(typeof value === 'string'){
            return value
        }

        if(isNumber(value)){
            if(decimals){
                return parseFloatNumber(value, decimals);
            }else{
                return parseFloatNumber(value);
            }
            
        }

        if(typeof value === 'boolean'){
            return value ? 'Si' : 'No';
        }

        return '-'
    }